import React, { useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import {
	faGauge,
	faUsers,
	faGopuram,
	faHotel,
	faGear,
	faGears,
	faFileImport,
	faFileExcel,
	faMoneyBill,
	faFileInvoice,
	faUserGroup
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons/faLocationDot';
import BookingDhamLogo from '../../../../assets/images/BookingDhamLogo.png';
import BookingDhamLogoSmall from '../../../../assets/images/logo.png';

const SidebarView = observer(({ collapsed }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const [menu, setMenu] = useState([]);
	const [defaultOpenKeys, setDefaultOpenKeys] = useState([
		location.pathname.split('/')[1],
	]);

	const getItem = (label, key, icon, children, type) => {
		return { key, icon, children, label, type };
	};

	useEffect(() => {
		setMenu([
			getItem(
				'Dashboard',
				'/dashboard',
				<FontAwesomeIcon icon={faGauge} />
			),
			getItem(
				'Temples',
				'/temples',
				<FontAwesomeIcon icon={faGopuram} />
			),
			getItem(
				'Accommodation',
				'/accommodation',
				<FontAwesomeIcon icon={faHotel} />
			),
			// getItem(
			// 	'Merchant',
			// 	'/merchant',
			// 	<FontAwesomeIcon icon={faUsers} />
			// ),
			getItem('Users', '/users', <FontAwesomeIcon icon={faUsers} />),
			getItem(
				'Settings',
				'/admin-settings',
				<FontAwesomeIcon icon={faGears} />
			),
			getItem(
				'Region',
				'/region',
				<FontAwesomeIcon icon={faLocationDot} />
			),
			//getItem('Settings', '/setting', <FontAwesomeIcon icon={faGear} />),
			getItem(
				'Bulk Import',
				'bulk-import',
				<FontAwesomeIcon icon={faFileExcel} />,
				[
					getItem(
						'Temples',
						'/bulk-import/temple',
						<FontAwesomeIcon icon={faFileImport} />
					),
					getItem(
						'Accommodation',
						'/bulk-import/accommodation',
						<FontAwesomeIcon icon={faFileImport} />
					),
				]
			),
			getItem(
				'Public Settings',
				'/public-settings',
				<FontAwesomeIcon icon={faGear} />
			),
			getItem(
				'Booking Invoice',
				'/bookinginvoice',
				<FontAwesomeIcon icon={faFileInvoice} />
			),
			getItem(
				'Payments',
				'/payments',
				<FontAwesomeIcon icon={faMoneyBill} />
			),
			getItem(
				'Customers',
				'/customers',
				<FontAwesomeIcon icon={faUserGroup} />
			),
		]);
	}, []);

	useEffect(() => {
		if (location.pathname.split('/').includes('accounts')) {
			setDefaultOpenKeys([location.pathname.split('/')[1]]);
		}
	}, [location]);

	return (
		<Layout.Sider
			collapsed={collapsed}
			width={'230px'}
			collapsedWidth={75}
			className="main__page__appsidebar"
		>
			<div className="logo__wrapper" style={{ padding: '5px' }}>
				{collapsed ? (
					// <h2
					// 	style={{ color: '#fff', marginBottom: 0, marginTop: 0 }}
					// >
					// 	BD
					// </h2>
					<img src={BookingDhamLogoSmall} alt="" width={'40px'} />
				) : (
					// <h2
					// 	style={{ color: '#fff', marginBottom: 0, marginTop: 0 }}
					// >
					// 	Booking Dham
					// </h2>
					<img src={BookingDhamLogo} alt="" width={'80px'} />
				)}
			</div>
			<Menu
				mode="inline"
				theme="dark"
				activeKey={location.pathname}
				items={menu}
				onClick={(item) => navigate(item.key)}
				defaultOpenKeys={defaultOpenKeys}
			></Menu>
		</Layout.Sider>
	);
});

export default SidebarView;
